import React from 'react';
import { LazyVideo } from '../common/LazyVideo';

interface ExperienceCardProps {
  gifDark: string;
  gifLight: string;
  videoKey?: string; // Optional: key for optimized video
  title: string;
  description: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isDark: boolean;
}

export function ExperienceCard({ gifDark, gifLight, videoKey, title, description, isDark }: ExperienceCardProps) {
  return (
    <div
      className="
        relative h-full rounded-2xl p-1.5
        bg-gradient-to-br from-primary-light/10 via-secondary-light/10 to-primary-light/10 
        dark:from-primary-dark/10 dark:via-secondary-dark/10 dark:to-primary-dark/10
        shadow-lg
        transition-transform duration-300 ease-out hover:scale-[1.02]
      "
    >
      <div
        className="
          group relative h-full overflow-hidden rounded-xl
          bg-gradient-to-br from-background-light/80 to-surface-light/80
          dark:from-background-dark/80 dark:to-surface-dark/80
          backdrop-blur-md
        "
      >
        {/* Background Video - Using LazyVideo for performance */}
        <div className="absolute inset-0">
          {videoKey ? (
            <LazyVideo
              darkSrc={gifDark}
              lightSrc={gifLight}
              videoKey={videoKey}
              isDark={isDark}
              autoPlay={true}
              muted={true}
              loop={true}
              playsInline={true}
            />
          ) : (
            <img src={isDark ? gifDark : gifLight} alt={title} className="w-full h-full object-cover" />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        </div>

        {/* Content */}
        <div className="relative h-full p-4 flex flex-col justify-end">
          <h3 className="text-xl font-bold text-white mb-2">
            {title}
          </h3>
          <p className="text-white/80 text-sm">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}